<div class="d-flex gap-1" [ngClass]="innerClass">
  <div class="text-uppercase fs-13 text-neutral-dark-grey fw-5" [ngClass]="textClass">{{ text }}</div>
  <div class="border-bottom flex-grow-1 ml-px-3 mb-px-3"></div>
</div>
